import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useEvent } from '@hooks/useEvent'
import { itemActions } from '../../AES_App/reducer/ItemSlice'
import { addExtraSpace } from '../utils'

export const useMultipleMerchandiseParties = ({ invoiceId, merchandiseId, containerKey }) => {
    const { isLoading, saveForm, deleteForm } = useEvent('invoiceTab', true)
    const dispatch = useDispatch()

    const {
        addMerchandiseParties,
        updateMerchandiseParties,
        deleteMerchandiseParties
    } = itemActions

    const addItem = useCallback(
        async (tableName, params = {}) => {
            try {
                const response = await saveForm(
                    {
                        merchandiseMap: {
                            [`${merchandiseId}`]: {
                                invoiceId,
                                [containerKey]: {
                                    [`${tableName}`]: [
                                        {
                                            id: '',
                                            merchandiseId,
                                            invoiceId,
                                            ...params,
                                        },
                                    ],
                                }
                            },
                        },
                    },
                    true
                )
                if (response) {
                    const data = response.invoiceTab.merchandiseMap[merchandiseId][containerKey][tableName][0]
                    // const data = { id: Math.random().toString() }
                    dispatch(
                        addMerchandiseParties({
                            data: { id: Math.random().toString(), ...data, invoiceId, merchandiseId, ...params },
                            meta: { containerKey, tableName },
                        })
                    )
                    // callback && callback(response)
                }
            } catch (e) {
                console.log(e)
            }
        },
        [invoiceId, merchandiseId]
    )

    const updateItem = useCallback(
        (id, tableName, payload) => {
            try {
                dispatch(
                    updateMerchandiseParties({
                        id,
                        data: { ...addExtraSpace(payload), invoiceId, merchandiseId },
                        meta: { containerKey, tableName },
                    })
                )

            } catch (e) {
                console.log(e)
            }
        },
        [invoiceId, merchandiseId]
    )

    const saveItem = useCallback(
        async (tableName, payload) => {
            try {
                const response = await saveForm(
                    {
                        merchandiseMap: {
                            [`${merchandiseId}`]: {
                                invoiceId: invoiceId,
                                [containerKey]: {
                                    [`${tableName}`]: Array.isArray(payload) ? addExtraSpace(payload) : [payload],
                                },
                            }
                        },
                    },
                    false
                )
            } catch { }
        },
        [invoiceId, merchandiseId]
    )

    const onSelect = useCallback(async (id, tableName, payload) => {
        try {
            updateItem(id, tableName, addExtraSpace(payload))
            const response = await saveItem(tableName, payload)
        } catch { }
    }, [])

    const deleteItem = useCallback(
        async (id, tableName) => {
            try {
                const response = await deleteForm({
                    merchandiseMap: {
                        [`${merchandiseId}`]: {
                            [containerKey]: {
                                [`${tableName}`]: [{ id }],
                            }
                        },
                    },
                })
                if (response)
                    dispatch(
                        deleteMerchandiseParties({
                            id,
                            data: { invoiceId, merchandiseId },
                            meta: { containerKey, tableName }
                        })
                    )
            } catch (e) { }
        },
        [invoiceId, merchandiseId]
    )

    return React.useMemo(
        () => ({
            addItem,
            deleteItem,
            updateItem,
            saveItem,
            onSelect,
            isLoading,
        }),
        [addItem, deleteItem, updateItem, saveItem, isLoading]
    )
}
